import $ from 'jquery';
import config from './../../../config';

// Get Users
export function get_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'permissions/',
			data: {
				method: 'GET_PERMISSION_USERS',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_PERMISSION_USERS",
				permission: response
			})
		})

	}
}

export function update_permission( user_id, permission){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'permissions/',
			data: {
				method: 'UPDATE_PERMISSION_USERS',
				user_id: user_id, 
				permission: permission
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_PERMISSION_USERS",
				permission: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/permissions/actions/permission.action.js